import React, {Component} from "react";
import {connect} from 'react-redux';
import Wizard from "../../../camvio-wizard/Wizard";
import Step from "../../../camvio-wizard/Step";

import {
    Provisioning,
    Confirmation,
} from "./Steps";

const STEPS = {
    PROVISIONING: 'provisioning-step',
    CONFIRMATION: 'confirmation-step',
}

class EquipmentAdd extends Component {

    componentDidMount() {
        const { accountDetailsWizardData, accountInfo } = this.props;
        document.title = 'Add Equipment - camvio.cloud';
        this.props.changeNavBarType('lock', 'addEquipmentWizard', 'Add Equipment');
        if ((!accountDetailsWizardData.wizardData.accountId) && (accountInfo.id)) {
          accountDetailsWizardData.wizardData.accountId = accountInfo.id;
        }
    }

    componentWillUnmount() {
        const {changeNavBarType, hideAccountDetailsWizard, documentTitle, navbarTitle} = this.props;

        // Change navbar type and color
        document.title = documentTitle;
        changeNavBarType('account', 'accountDetails', navbarTitle);

        hideAccountDetailsWizard();
    }

    render() {
        const { accountDetailsWizardData, history, hideAccountDetailsWizard } = this.props;

        return (
            <Wizard name='AddEquipmentWizard'>

                <Step
                    wizardData={accountDetailsWizardData.wizardData}
                    name={STEPS.PROVISIONING}
                    title='Add Equipment'
                    component={Provisioning}
                    next={STEPS.CONFIRMATION}
                    history={history}
                />

                <Step
                    wizardData={accountDetailsWizardData.wizardData}
                    name={STEPS.CONFIRMATION}
                    title='Confirmation'
                    component={Confirmation}
                    history={history}
                    hideAccountDetailsWizard={hideAccountDetailsWizard}
                />

            </Wizard>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentAdd);